module.exports = __webpack_public_path__ + "static/media/MarkTwain.1489ae92.jpg";